"use client";

import React from "react";
import { FileText, Download, Loader, CircleAlert } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
function MarketInsightsGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="rounded-none border-border/20 bg-card/10">
            <AspectRatio ratio={3 / 4}>
              <div className="flex h-full w-full items-center justify-center">
                <Loader className="size-8 animate-spin text-muted-foreground/50" />
              </div>
            </AspectRatio>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <CircleAlert className="mb-4 size-12 text-destructive/80" />
        <p className="text-lg font-medium text-foreground">Failed to load market insights.</p>
        <p className="text-sm text-muted-foreground">Please try refreshing the page.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="py-12 text-center">
        <p className="text-lg text-muted-foreground">No whitepapers available at this time.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      const readTime = post.content ? Math.max(3, Math.ceil(post.content.split(' ').length / 200)) : 5;
      return <Card key={post.id} data-index={i} className="group relative overflow-hidden rounded-none border-border/40 bg-card/20 transition-colors duration-500 hover:border-primary/60">
            <AspectRatio ratio={3 / 4}>
              <div className="flex h-full flex-col justify-between p-8">
                <div className="flex items-start justify-between">
                  <div className="rounded-sm bg-background/50 p-3 backdrop-blur-sm">
                    <FileText className="size-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <Badge variant="outline" className="border-border/50 bg-background/50 font-mono text-[10px] tracking-widest text-muted-foreground backdrop-blur-sm">
                    {readTime} MIN READ
                  </Badge>
                </div>

                <div className="mt-auto">
                  <h3 className="font-serif text-2xl font-medium leading-tight text-foreground/90 transition-colors duration-300 group-hover:text-primary line-clamp-4">
                    {post.title}
                  </h3>
                  {post.excerpt && <div className="mt-4 text-sm text-muted-foreground line-clamp-2" dangerouslySetInnerHTML={{
                __html: post.excerpt
              }} />}
                </div>
              </div>

              <div className="absolute inset-0 flex items-center justify-center bg-background/95 opacity-0 backdrop-blur-md transition-all duration-300 group-hover:opacity-100 group-focus-within:opacity-100">
                <Link to={post.link || "#"} newTab>
                  <Button variant="outline" className="rounded-none border-primary/50 bg-transparent font-mono text-xs uppercase tracking-widest text-primary hover:bg-primary hover:text-primary-foreground">
                    Download PDF
                    <Download className="ml-2 size-4" />
                  </Button>
                </Link>
              </div>
            </AspectRatio>
          </Card>;
    })}
    </div>;
}
export default function MarketInsights() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query("post", wp_query_params);
  return;
}